import {
  TimeoutWrapper,
  TimeoutWrapperService,
  UserService
} from '@nrwl/common-lib';

import {
  Component,
  EventEmitter,
  Output,
  OnChanges,
  Input,
  ViewChild,
  AfterViewInit,
  OnInit,
  OnDestroy
} from '@angular/core';

import { NgForm, NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'claim-code',
  templateUrl: './claim.code.template.html'
})
export class ClaimCodeComponent implements OnInit, OnDestroy {
  userService: UserService;
  @Input() parentOutput: any;
  @Input() step: any;
  @Output() onUpdate: EventEmitter<any> = new EventEmitter();
  @Input() key: string;
  @ViewChild('claimInput', { static: true }) claimInput: NgModel;

  claimCodeIsValid: boolean;
  hwLockCode: string;

  valueChangeSubscription: Subscription;
  statusChangeSubscription: Subscription;

  constructor(userService: UserService) {
    this.userService = userService;
    this.claimCodeIsValid = false;
  }

  ngOnInit() {
    this.valueChangeSubscription = this.claimInput.valueChanges.subscribe(
      changes => {
        this.onClaimCodeChange();
      }
    );
    this.statusChangeSubscription = this.claimInput.statusChanges.subscribe(
      changes => {
        this.onClaimCodeChange();
      }
    );
  }

  ngOnDestroy() {
    this.valueChangeSubscription.unsubscribe();
    this.statusChangeSubscription.unsubscribe();
  }

  // triggered on claim code changes. we should review if the code is valid and emit appropriate event
  onClaimCodeChange() {
    if (!this.hwLockCode) {
      this.onUpdate.emit({
        key: this.key,
        value: this.hwLockCode,
        isValid: false
      });
      return;
    }
    switch (this.claimInput.status) {
      case 'VALID':
        {
          this.claimCodeIsValid = true;
          this.onUpdate.emit({
            key: this.key,
            value: this.hwLockCode,
            isValid: true
          });
        }
        break;
      default: {
        // for PENDING and INVALID emit 'isValid=false' to be sure user does not go ahead until validation is over
        this.claimCodeIsValid = false;
        this.onUpdate.emit({
          key: this.key,
          value: this.hwLockCode,
          isValid: false
        });
      }
    }
  }
}
